module.exports = __webpack_public_path__ + "img/rg-back.f699f728.png";